<template lang="pug">
    .cursor(:class="{drag_cursor, hide_cursor}")
        .cursor.cursor--small
        canvas.cursor.cursor--canvas
</template>

<script>
    export default {
        name: "Cursor",


        data: ()=>({
            drag_cursor: false,
            hide_cursor: false,
        }),
        computed:{
            isMobileDevice(){
                return this.$store.state.isMobileDevice;
            },
        },
        methods:{
            init(){
                /*        init dot        */
                let clientX = -100;
                let clientY = -100;
                const innerCursor = document.querySelector(".cursor--small");
                const initCursor = () => {
                    let body = document.querySelector('body');
                    body.addEventListener("mousemove", e => {
                        if  (e.target.closest('[data-hover]')){
                            this.hide_cursor = true;
                        } else if (e.target.closest('.main_popup .left_side')){
                            this.hide_cursor = false;
                            if (!this.drag_cursor) {
                                this.drag_cursor = true;
                            }
                        }else {
                            this.drag_cursor = false;
                            this.hide_cursor = false;
                        }
                        clientX = e.clientX;
                        clientY = e.clientY;
                    });
                    const render = () => {
                        innerCursor.style.transform = `translate(${clientX}px, ${clientY}px)`;
                        requestAnimationFrame(render);
                    };
                    requestAnimationFrame(render);
                };
                initCursor();

                /*         init circle          */
                let lastX = 0;
                let lastY = 0;
                let group;

                const initCanvas = () => {
                    const canvas = document.querySelector(".cursor--canvas");
                    const shapeBounds = {
                        width: 75,
                        height: 75
                    };
                    paper.setup(canvas);
                    const strokeColor = "rgba(255, 0, 0, 0.5)";
                    const strokeWidth = 1;
                    const segments = 8;
                    const radius = 15;

                    // we'll need these later for the noisy circle
                    const noiseScale = 150; // speed
                    const noiseRange = 4; // range of distortion
                    let isNoisy = false; // state

                    // the base shape for the noisy circle
                    const polygon = new paper.Path.RegularPolygon(
                        new paper.Point(0, 0),
                        segments,
                        radius
                    );
                    polygon.strokeColor = strokeColor;
                    polygon.strokeWidth = strokeWidth;
                    polygon.smooth();
                    group = new paper.Group([polygon]);
                    group.applyMatrix = false;

                    const noiseObjects = polygon.segments.map(() => new SimplexNoise());
                    let bigCoordinates = [];

                    // function for linear interpolation of values
                    const lerp = (a, b, n) => {
                        return (1 - n) * a + n * b;
                    };

                    // function to map a value from one range to another range
                    const map = (value, in_min, in_max, out_min, out_max) => {
                        return (
                            ((value - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min
                        );
                    };

                    // the draw loop of Paper.js
                    // (60fps with requestAnimationFrame under the hood)
                    paper.view.onFrame = event => {
                        // using linear interpolation, the circle will move 0.2 (20%)
                        // of the distance between its current position and the mouse
                        // coordinates per Frame
                        lastX = lerp(lastX, clientX, 0.2);
                        lastY = lerp(lastY, clientY, 0.2);
                        group.position = new paper.Point(lastX, lastY);
                    }
                }

                initCanvas();

            },
        },
        mounted() {
            if (!this.isMobileDevice){
                this.init();
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/scss/_functions.scss";
    @import "@/assets/scss/_variables.scss";
    @import "@/assets/scss/_mixins.scss";
    .cursor {
        position: absolute;
        left: 0;
        top: 0;
        pointer-events: none;
        z-index: 1000;
        transition: opacity .2s;
    }
    .cursor--small {
        width: to_rem(45px);
        height: to_rem(20px);
        left: to_rem(-22px);
        top: to_rem(-10px);
        border-radius: 50%;
        z-index: 11000;
        background: url(../../assets/img/cursor.png) no-repeat center center / contain;
    }
    .drag_cursor .cursor--small{
        background-image: url(../../assets/img/slider_cursor.png);
    }
    .hide_cursor{
        opacity: 0;
    }
    .cursor--canvas {
        width: 100vw;
        height: 100vh;
        z-index: 12000;
    }



    .mobile{
        .cursor{
            display: none;
        }
    }
</style>
